import * as React from 'react'
import classNames from 'classnames'
// styles
import './styles.css'

const BookADemoButton = ({ label = 'Book a Demo', className = '' }) => (
  <a href='/contact' className={classNames('book-demo-button', className)}>
    {label}
  </a>
)

export default BookADemoButton
